import { AccountService } from "@3gaam/api/services";
import {
  LoginByPasswordInput,
  LoginByPasswordOutput,
  TokenOutput,
} from "@3gaam/api/types/account";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

type AuthState = {
  isLoggedIn: boolean;
  isTokenValid: boolean;
  token: TokenOutput | null;
  authError: any | null;
};

const initialToken = () => { 
  const auth = localStorage.getItem("auth");
  return auth ? JSON.parse(auth) : null;
}

const initialState: AuthState = {
  isLoggedIn: true,
  isTokenValid: false,
  token: initialToken(),
  authError: null,
};

export const loginByPasswordAction = createAsyncThunk<
  LoginByPasswordOutput,
  LoginByPasswordInput
>("planning/unplanResource", async (payload, thunkAPI) => {
  try {
    const res = await AccountService.loginByPassword(payload);
    return res.data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsTokenValidAction: (state, action: PayloadAction<boolean>) => {
      state.isTokenValid = action.payload;
    },
    setIsLoggedInAction: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginByPasswordAction.fulfilled, (state, action) => {
        if (action.payload?.Token) {
          localStorage.setItem("auth", JSON.stringify(action.payload.Token));

          state.token = action.payload.Token;
          state.isTokenValid = true;
        }
        state.isLoggedIn = true;
      })
  },
});

export const { setIsLoggedInAction, setIsTokenValidAction } = authSlice.actions;

export default authSlice.reducer;
